/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tour_Dark_DescInputs */

const en_wc_tour_dark_desc = /** @type {(inputs: Wc_Tour_Dark_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A real dark theme with formatting marks, plus the full Insert tab.`)
};

/**
* | output |
* | --- |
* | "A real dark theme with formatting marks, plus the full Insert tab." |
*
* @param {Wc_Tour_Dark_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tour_dark_desc = /** @type {((inputs?: Wc_Tour_Dark_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tour_Dark_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tour_dark_desc(inputs)
});
export { wc_tour_dark_desc as "wc.tour.dark.desc" }